import {
  fonts,
  fontWeights,
  colors,
  measurements,
  fontSizes,
  BREAKPOINTS
} from 'app/theme'
import css from 'styled-jsx/css'

export const quickAccess = css`
  .new-section {
    display: flex;
    width: 100%;
  }
  .bin {
    background: white;
    margin-top: 2rem;
    width: 100%;
  }
  .bin .image img {
    width: 9rem;
    float: right;
  }

  .cover {
    position: relative;
    display: flex;
  }

  .content {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: ${colors.white};
  }
  .image-cover {
    width: 100%;
    min-height: 25rem;
  }
  .new-section .new-section-title {
    font-size: ${fontSizes.body};
    font-weight: ${fontWeights.bold};
    max-width: 100%;
    text-align: center;
    margin-bottom: 0.5rem;
    color: ${colors.alpha(colors.white, 0.5)};
  }
  .new-section-title .title-in-block {
    display: block;
    color: ${colors.white};
  }
  .title-in-block.title-highlited {
    font-size: ${fontSizes.h1};
    line-height: 2.5rem;
    font-weight: ${fontWeights.bold};
  }
  .title-in-block.title-custom {
    font-size: ${fontSizes.h5};
    font-weight: ${fontWeights.bold};
  }
  .new-section .subtitle {
    font-weight: ${fontWeights.semiBold};
    font-size: ${fontSizes.p};
    color: ${colors.white};
    margin-bottom: 1.5rem;
    text-align: center;
  }
  .contract-container {
    display: flex;
    width: 100%;
  }
  .contract-container .contract-item {
    flex: 1;
    display: flex;
    margin: 0 1.5rem;
    width: 100%;
  }
  .contract-item-description {
    margin-left: 1rem;
  }
  .contract-item-description .additional-description {
    display: block;
    font-size: ${fontSizes.small};
    margin-top: 0.5rem;
    font-weight: lighter;
  }
  .download-contract {
    margin-top: 1.5rem;
    padding: 0.2rem 1.5rem;
    border-radius: ${measurements.borderRadius};
    background-color: ${colors.primary};
  }
  .stadistics {
    display: flex;
    justify-content: center;
    flex: 1;
    margin-top: 1rem;
  }
  .stadistic a {
    color: unset;
    margin: 0;
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .stadistic {
    justify-content: center;
    display: flex;
    align-items: center;
    cursor: pointer;
    flex-flow: row;
    background: white;
    flex: 1;
    border: solid 0.75rem ${colors.white};
    margin: 0.5rem 1rem;
  }
  .stadistic:first-child {
    margin-left: 0;
  }
  .stadistic:last-child {
    margin-right: 0;
  }
  .stadistic:hover {
    background: ${colors.lightGray};
    box-shadow: 1px 2px 3px ${colors.grayBackground};
  }
  .stadistic strong {
    font-size: 4rem;
    margin: 0;
    font-weight: 300;
    margin: 0 1rem;
    color: ${colors.primary};
  }
  .stadistic p {
    margin: 0 1rem;
  }
  .stadistic p span {
    font-size: 0.8rem;
  }
  .stadistic :global(.icon) {
    font-size: 4.5rem;
    display: flex;
  }
  .chart {
    width: 100%;
    background: ${colors.white};
    padding: 1rem;
  }
  .paddedSides {
    padding: 0 0.75rem;
  }
  .additional-title {
    font-weight: ${fontWeights.bold};
  }

  @media screen and (max-width: ${BREAKPOINTS.LG}) {
    .image-cover {
      min-height: 26rem;
    }
    .new-section .new-section-title {
      margin-top: 0;
      max-width: 100%;
    }
    .contract-container .contract-item {
      justify-content: center;
      align-items: center;
    }
  }

  @media screen and (max-width: ${BREAKPOINTS.MD}) {
    .bin .action {
      width: auto;
    }
    .bin .image {
      text-align: center;
    }
    .bin .image img {
      float: none;
    }
    .stadistics {
      flex-flow: column;
    }
    .stadistic {
      padding: 0;
      margin: 1rem 0;
    }
    .stadistic p {
      margin: 1rem;
    }
    .new-section .new-section-title {
      max-width: 90%;
      text-align: center;
      margin-top: 0;
    }
    .new-section .subtitle {
      margin: 0.5rem 0.5rem;
    }
    .new-section .new-section-description {
      font-size: ${fontSizes.p};
      text-align: center;
    }
    .contract-container {
      flex-direction: column;
      margin-top: 1rem;
      width: 90%;
      justify-content: center;
      align-items: center;
    }
    .contract-container .contract-item {
      margin: 0 0 0.5rem 0;
      justify-content: center;
      align-items: center;
    }
    .contract-item-description {
      flex: 2;
    }
    .image-cover {
      object-fit: cover;
      min-height: 38rem;
    }
  }

  @media screen and (max-width: ${BREAKPOINTS.SM}) {
    .content .subtitle {
      font-size: ${fontSizes.small};
      line-height: 1.25rem;
      font-weight: normal;
    }

    .image-cover {
      min-height: 45rem;
    }
    .title-in-block.title-custom {
      font-size: ${fontSizes.p};
      font-weight: ${fontWeights.bold};
    }
    .stadistics .container {
      display: flex;
      flex-direction: column;
    }

    .stadistic a {
      display: flex;
      flex-direction: column;
    }
  }
`
